<template>
  <div class="company">
    <InputComponent v-model="value.name" :label="labels.name" data-field="name" v-bind="fieldProps.name" />
    <MediaComponent
      v-if="enableLogo"
      v-model="logoComp"
      :label="$t('logo')"
      data-field="logo"
      :upload-options="{ compression: { maxWidth: 700 } }"
      size="contain"
      :description="false"
    />
    <InputComponent
      v-model="value.organizationNumber"
      :label="labels.organizationNumber"
      data-field="organizationNumber"
      v-bind="fieldProps.organizationNumber"
    />
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { MediaComponent } from '@kvass/media'
import { mapi18n } from '@/i18n'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    validator: Object,
    validatorPrefix: {
      type: String,
      default: '',
    },
    enableLogo: Boolean,
  },
  computed: {
    fieldProps() {
      if (!this.validator) return {}

      return Object.fromEntries(
        ['name', 'organizationNumber'].map(key => {
          let fullKey = [this.validatorPrefix, key].join('.')
          let fieldValidator = this.validator.fields[fullKey]
          return [
            key,
            {
              required: fieldValidator && fieldValidator.rule.includes('required'),
              isValid: fieldValidator && fieldValidator.valid,
              validationMessage: fieldValidator && fieldValidator.error,
            },
          ]
        }),
      )
    },
    logoComp: {
      get() {
        if (!this.value.logo) return
        return {
          url: this.value.logo,
          type: 'image/jpeg',
        }
      },
      set(newValue) {
        this.value.logo = newValue ? newValue.url : null
      },
    },
    ...mapi18n('labels', { name: 'companyName', organizationNumber: 'orgNo' }),
  },
  components: {
    InputComponent,
    MediaComponent,
  },
}
</script>

<style lang="scss">
.company {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;

  [data-field='logo'] {
    grid-row-end: span 2;
  }
}
</style>
